import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import { Card, Flex, Heading, Spacer, Td, Text, Tr } from "@chakra-ui/react";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import {
  get_all_inventory_list,
  get_inventory_list,
} from "../../redux/inventorySlice";
import { get_all_customer_list } from "../../redux/customerSlice";
import { get_all_dp_list } from "../../redux/dplistSlice";
import CustomSingleInput from "../../components/CustomSingleInput";
import { baseUrl } from "../../utils/utils";
import Loader from "../../components/Loader";

const SalesReports = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [total_count, setTotal_count] = useState(0);
  const [salesType, setSalesType] = useState("");
  const [reports_list, setReports_list] = useState([]);
  const [loading, setLoading] = useState(false);
  const { all_inventory_list } = useSelector((state) => state.inventory);
  const { all_customer_list } = useSelector((state) => state.customers);
  const { all_dp_list } = useSelector((state) => state.dplist);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState({});

  const product_list = all_inventory_list?.map((v) => ({
    label: `${v?.product_name} - ${v?.type}`,
    value: v?.uuid,
  }));
  const customer_list = all_customer_list?.map((v) => ({
    label: v?.name,
    value: v?.id,
  }));

  const dp_list = all_dp_list?.map((v) => ({
    label: v?.name,
    value: v?.id,
  }));
  // console.log(all_dp_list,"cusurl")
  console.log(all_customer_list, "newData");

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `inventory.php`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_inventory_list({ page, rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch {
      toast.error("Failed to load product data");
    } finally {
      setIsLoading(false);
    }
  };

  const get_report_list = async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("action", salesType);
      formData.append("page", page);
      formData.append("limit", rows);
      formData.append("fd", startDate);
      formData.append("td", endDate);
      if (salesType === "customer") {
        formData.append("userid", selectedProduct);
      } else if (salesType === "product") {
        formData.append("prod_code", selectedProduct);
      } else if (salesType === "delivery_partner") {
        formData.append("dpid", selectedProduct);
      }

      const response = await fetch(`${baseUrl}reports/sales_report.php`, {
        method: "POST",
        body: formData,
      });

      const res = await response.json();

      if (res?.success) {
        setReports_list(res?.list);
        setTotal_count(res.totalcount);
      } else {
        setReports_list([]);
        setTotal_count(0);
      }
    } catch {
      console.log("Failed to fetch sales report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    store.dispatch(get_all_inventory_list());
    store.dispatch(get_all_customer_list());
    store.dispatch(get_all_dp_list());
  }, []);

  useEffect(() => {
    if (salesType && selectedProduct && startDate && endDate) {
      get_report_list();
    }
  }, [page, rows, salesType, selectedProduct, startDate, endDate]);

  return (
    <>
      <Card
        bg="#fff"
        py={3}
        px={5}
        flexDirection={["column", "row"]}
        alignItems={["flex-start", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading w="full" fontSize="xl">
          Sales Reports
        </Heading>
        <Spacer display={["none", "block"]} />
      </Card>

      <Card bg="#fff" py={3} px={5}>
        <Flex direction={["column", "row"]} wrap="wrap" gap={3} mb={3}>
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Select Type of Sales"
            placeholder="Select Type"
            select
            options={[
              { label: "Customer", value: "customer" },
              { label: "Product", value: "product" },
              { label: "Delivery Partner", value: "delivery_partner" },
            ]}
            value={salesType}
            onChange={(e) => {
              setSalesType(e.target.value);
              // console.log(e.target.value,"clicc")
              setSelectedProduct(null);
            }}
          />
          {salesType && (
            <CustomSingleInput
              width={["100%", "200px"]}
              label={
                salesType === "customer"
                  ? "Customer Name"
                  : salesType === "product"
                  ? "Product Name"
                  : "Delivery Partner Name"
              }
              placeholder="Select"
              select
              options={
                salesType === "customer"
                  ? customer_list
                  : salesType === "product"
                  ? product_list
                  : dp_list
              }
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
            />
          )}
          <CustomButton
            title="Search"
            w={["100%", "auto"]}
            onClick={() => {
              setData({
                sd: startDate,
                ed: endDate,
                pcode: selectedProduct,
                stype: salesType,
              });
              get_report_list();
            }}
          />
        </Flex>

        {data?.sd && (
          <Text>
            From Date: <b>{data.sd}</b> To Date: <b>{data.ed}</b> Sales Type:{" "}
            <b>
              {data.stype === "customer"
                ? "Customer"
                : data.stype === "product"
                ? "Product"
                : "Delivery Partner"}
            </b>{" "}
            {data.stype === "customer"
              ? "Customer Name"
              : data.stype === "product"
              ? "Product Name"
              : "Delivery Partner Name"}
            :{" "}
            <b>
              {data.stype === "customer"
                ? customer_list?.find((v) => v.value === data.pcode)?.label
                : data.stype === "product"
                ? product_list?.find((v) => v.value === data.pcode)?.label
                : dp_list?.find((v) => v.value === data.pcode)?.label}
            </b>
          </Text>
        )}
      </Card>

      {loading ? (
        <Card justify="center" align="center" p={5}>
          <Loader />
        </Card>
      ) : reports_list?.length === 0 ? (
        <Card justify="center" align="center" h={20}>
          <Text>No Data</Text>
        </Card>
      ) : (
        <Card>
          <TableView
            headData={[
              "S.No.",
              "Order ID",
              "Product name",
              "Quantity",
              "Empty received",
              "return cylinder",
              "bank name",
              "a/c no.",
              "Transaction No.",
              "payment mode",
               "cash received",
               "online received",
              "Total Amount",
              "delivery person name",
              "datetime",
            ]}
            body={reports_list?.map((el, i) => (
              <Tr key={i}>
               <Td textAlign="center">{(page - 1) * rows + i + 1}</Td>
                <Td textAlign="center">{el.orderid ?el.orderid :"NA"}</Td>
                <Td textAlign="center">{el.product_name?el.product_name:"NA"}</Td>
                <Td textAlign="center">{el.quantity ? el.quantity :"NA"}</Td>
                <Td textAlign="center">{el.empty_received ? el.empty_received :"NA"}</Td>
                <Td textAlign="center">{el.returnclinder ? el.returnclinder :"NA"}</Td>
                <Td textAlign="center">{el.bankname ? el.bankname : "NA"}</Td>
                <Td textAlign="center">
  {el.accountno ? `XXXX${el.accountno.slice(-4)}` : "NA"}
</Td>
                <Td textAlign="center">{el.transaction_no ?el.transaction_no:"NA" }</Td>
                <Td textAlign="center">{el.payment_mode ? el.payment_mode :"NA"}</Td>
                <Td textAlign="center">{el.cash_received ? el.cash_received :"NA"}</Td>
                <Td textAlign="center">{el.online_received ?el.online_received :"NA"}</Td>
                <Td textAlign="center">{el.totalamount ? el.totalamount :"NA"}</Td>
                <Td textAlign="center">{el.delivery_person_name ? el.delivery_person_name : "N/A"}</Td>
                <Td textAlign="center">{el.datetime?el.datetime:"NA"}</Td>
              </Tr>
            ))}
            initialValue={initialValue}
            page={page}
            rows={rows}
            total_value={total_count}
            pagination
            onChange={(e) => {
              setpage(1);
              setRows(Number(e.target.value));
              if (salesType && selectedProduct && startDate && endDate) {
                get_report_list();
              } else {
                store.dispatch(get_inventory_list({ page: 1, rows: Number(e.target.value) }));
              }
            }}
           
             onPrevious={() => {
            if (page > 1) {
            setpage(page - 1);
            if (salesType && selectedProduct && startDate && endDate) {
            get_report_list();
            } else {
            store.dispatch(get_inventory_list({ page: page - 1, rows }));
            }
           }
          }}
            onNext={() => {
             if (rows * page < total_count) {
            setpage(page + 1);
            if (salesType && selectedProduct && startDate && endDate) {
             get_report_list();
            } else {
            store.dispatch(get_inventory_list({ page: page + 1, rows }));
             }
             }
            }}
          />
          <ConfirmDialog
            isOpen={deleteDialog}
            onClose={() => setDeleteDialog(false)}
            onConfirm={handleDelete}
            type="delete"
            title="Delete Inventory"
            message="Are you sure you want to delete this Inventory? This action cannot be undone and will remove all associated data."
            confirmText="Delete"
            cancelText="Cancel"
            isLoading={isLoading}
          />
        </Card>
      )}
    </>
  );
};

export default SalesReports;
